module.exports = __webpack_public_path__ + "static/other/gameFossilFinder.4fd2ebf4.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameFossilFinder.json
// module id = 2612
// module chunks = 0